import request from '@/utils/request'

export function fetchAgentList (query) {
  return request({
    url: '/card/api/agent/index',
    method: 'get',
    params: query
  })
}

export function agentSum (query) {
  return request({
    url: '/card/api/agent/sum',
    method: 'get',
    params: query
  })
}

export function fetchAgentParentList (query) {
  return request({
    url: '/card/api/agent/getParent',
    method: 'get',
    params: query
  })
}

export function fetchAgent (id) {
  return request({
    url: '/card/api/agent/view',
    method: 'get',
    params: { id }
  })
}

export function createAgent (data) {
  return request({
    url: '/card/api/agent/insert',
    method: 'post',
    data
  })
}

export function updateAgent (data) {
  return request({
    url: '/card/api/agent/update',
    method: 'post',
    data
  })
}

export function deleteAgent (id) {
  return request({
    url: '/card/api/agent/delete',
    method: 'post',
    params: { id }
  })
}

export function info () {
  return request({
    url: '/card/api/agent/info',
    method: 'get',
    params: {}
  })
}

export function withdrawalSet (userId, minAmount, multiple) {
  return request({
    url: '/card/api/agent/withdrawalSet',
    method: 'post',
    data: {
      user_id: userId,
      min_amount: minAmount,
      multiple: multiple
    }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/agent.js